var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSmokingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_8862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1131 12.3991H20.2881V14.6793H19.1131V12.3991ZM17.1549 12.3991H18.3298V14.6793H17.1549V12.3991ZM16.3716 12.3991H14.5386L16.3716 14.1777V12.3991ZM14.4133 9.09264H15.6118C16.4342 9.09264 17.1549 9.65511 17.1549 10.6508V11.639H18.3298V10.3924C18.3298 9.01663 17.0765 7.9905 15.6118 7.9905H14.4133C13.6143 7.9905 12.9642 7.24561 12.9642 6.47031C12.9642 5.69501 13.6143 5.14014 14.4133 5.14014V4C12.9642 4 11.7893 5.14014 11.7893 6.54632C11.7893 7.95249 12.9642 9.09264 14.4133 9.09264ZM17.8207 6.11306C18.3063 5.64941 18.604 5.01093 18.604 4.30404H17.429C17.429 5.07933 16.7789 5.71021 15.9799 5.71021V6.85036C17.7345 6.85036 19.1131 8.24133 19.1131 9.94394V11.639H20.2881V9.93634C20.2881 8.24893 19.2854 6.78955 17.8207 6.11306ZM5.72652 6.00665L4.62207 7.07839L10.1052 12.3991H4.62207V14.6793H12.4551L17.9382 20L19.0426 18.9283L5.72652 6.00665Z",
    fill: "#494949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_8862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7327,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSmokingIcon);
export default __webpack_public_path__ + "static/media/NoSmokingIcon.538c7cd511414bbbce489bed87949471.svg";
export { ForwardRef as ReactComponent };